module.exports = __webpack_public_path__ + "static/media/NenadLecic.7773525d.jpg";